/**
 * Default case for switch statements so TypeScript notifies if we fail to cover a case
 * @param arg The value of the expression executed in the default case
 *
 * @returns The value of the expression executed in the default case
 */

export const exhaustiveCheck = (arg: never) => arg
